import { css } from 'linaria';
import { styled } from 'linaria/react';

export const bannerLink = css`
  width: 100%;
`;

export const StyledBanner = styled.div`
   width: 100%;
`;

export const bannerImage = css`
  display: block;
  width: 100%;
  height: 100%;
  border-radius: var(--rounding-l);
`;
